"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Vue, Component, PropSync } from "vue-property-decorator";
import UiMenuBar from "@/components/menu/UiMenuBar.vue";
import API from "@ym-framework/api-utils";
import MainViewMode from "@/components/virtual-element/elements/main-groups/MainViewMode.vue";
import Question from "@/components/Question.vue";
import draggable from "vuedraggable";
import _ from "lodash";
import { Debounce } from "vue-debounce-decorator";
export class Controller {
  constructor() {
    // public systems = new Array<GroupModel>();
    // public customs = new Array<GroupModel>();
    this.groups = new Array();
  }
}
let MainGroups = class extends Vue {
  collapse() {
  }
  mounted() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(
          "api://base.auth.pro/v1/groups",
          {
            params: {
              "type": "SHOP"
            }
          }
        );
        for (const _item of response.data.datas) {
          this._controller.groups.push(_item);
        }
        if (localStorage.getItem("shop.group") !== null) {
          let shop_group = localStorage.getItem("shop.group");
          if (shop_group.length > 19 && shop_group.indexOf("system") === -1) {
            localStorage.setItem("shop.group", response.data.datas[0].id);
          }
          let group_item = _.find(this._controller.groups, { "id": shop_group });
          if (!group_item || group_item === void 0 || group_item === null) {
            localStorage.setItem("shop.group", response.data.datas[0].id);
          }
          this._contentController.query.filter = {
            group: localStorage.getItem("shop.group")
          };
          let groupdata = _.find(this._controller.groups, {
            "id": localStorage.getItem("shop.group")
          });
          if (groupdata) {
            this._groupNum = groupdata.quantity;
          }
        } else {
          localStorage.setItem("shop.group", response.data.datas[0].id);
          this._contentController.query.filter = {
            group: response.data.datas[0].id
          };
          this._groupNum = this._controller.groups[0].quantity;
        }
        this._contentController.query.sort = "createdTime,desc";
        yield this._contentController.search();
        this.$nextTick(() => {
          let liElements = document.querySelectorAll(".el-menu-item");
          liElements.forEach((item) => {
            if (item.__vue__.$attrs.element === "system") {
              item.classList.add("system");
            }
          });
        });
      } catch (error) {
        console.log(error);
      }
    });
  }
  refresh() {
    return __async(this, null, function* () {
      try {
        this._controller.groups = new Array();
        const response = yield API.get(
          "api://base.auth.pro/v1/groups",
          {
            params: {
              "type": "SHOP"
            }
          }
        );
        for (const _item of response.data.datas) {
          this._controller.groups.push(_item);
        }
        this.$nextTick(() => {
          let liElements = document.querySelectorAll(".el-menu-item");
          liElements.forEach((item) => {
            if (item.__vue__.$attrs.element === "system") {
              item.classList.add("system");
            }
          });
          let shop_group = localStorage.getItem("shop.group");
          let group_item = _.find(this._controller.groups, { "id": shop_group });
          if (!group_item || group_item === void 0 || group_item === null) {
            localStorage.setItem("shop.group", response.data.datas[0].id);
            if (this._contentController.query.filter) {
              this._contentController.query.filter.group = localStorage.getItem("shop.group");
            } else {
              this._contentController.query.filter = {
                group: localStorage.getItem("shop.group")
              };
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    });
  }
  checkGroupMove() {
    this.$nextTick(() => {
      let liElements = document.querySelectorAll(".el-menu-item");
      liElements.forEach((item) => {
        if (item.__vue__.$attrs.element === "system") {
          item.classList.add("system");
        }
      });
    });
  }
  group_manage(e) {
    this.$store.dispatch("matomo", { that: this, e });
    this.$emit("openGroupDialog");
  }
  //拖拽
  onMove(e) {
    return e.relatedContext.index > 2;
  }
  checkMove(event) {
    return __async(this, null, function* () {
      try {
        const _ids = _.map(this._controller.groups, "id");
        yield API.put(`api://base.auth.pro/v1/groups-sorts`, {
          groupIds: _ids,
          type: "SHOP"
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  PropSync("owner")
], MainGroups.prototype, "_contentController", 2);
__decorateClass([
  PropSync("controller", {
    default: () => {
      return new Controller();
    }
  })
], MainGroups.prototype, "_controller", 2);
__decorateClass([
  PropSync("groupNum")
], MainGroups.prototype, "_groupNum", 2);
__decorateClass([
  Debounce(400)
], MainGroups.prototype, "checkMove", 1);
MainGroups = __decorateClass([
  Component({
    components: {
      UiMenuBar,
      MainViewMode,
      Question,
      draggable
    }
  })
], MainGroups);
export {
  MainGroups as default
};
